import { getDownloadSelectors, getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const communicationsDataSelector = getSelectors({
  getRootPath: selectorsConfig.communicationsDataSelector.getRootPath,
})

export const communicationDocumentDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.communicationDocumentDownloadSelector.getRootPath,
})
